import { update } from '@kundinos/nanostores';

import { orderFabricsStore } from './stores';

// Выбрать/снять образец ткани
function toggleSelect({ sample }: any): void {
  update(orderFabricsStore, (prevState) => {
    let newSelected = [...prevState.selectedSamples];
    const foundedIndex = newSelected.findIndex(
      (selected) => selected.sample?.value === sample.value,
    );

    if (foundedIndex > -1) {
      newSelected = [
        ...newSelected.slice(0, foundedIndex),
        ...newSelected.slice(foundedIndex + 1),
        { sample: null },
      ];
    } else {
      const freeIndex = newSelected.findIndex((selected) => !selected.sample);
      newSelected[freeIndex] = { sample };
    }

    return { ...prevState, selectedSamples: newSelected };
  });
}

export default toggleSelect;
